import { render, staticRenderFns } from "./FormCheckboxInput.vue?vue&type=template&id=22b9546f&scoped=true&"
import script from "./FormCheckboxInput.vue?vue&type=script&lang=js&"
export * from "./FormCheckboxInput.vue?vue&type=script&lang=js&"
import style0 from "./FormCheckboxInput.vue?vue&type=style&index=0&id=22b9546f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9546f",
  null
  
)

export default component.exports